<template>
  <suggestions
    v-model="query"
    :options="options"
    :onItemSelected="onItemSelected"
    :onInputChange="onInputChange"
  >
    <div slot="item" slot-scope="props" class="single-item">
      <strong>{{props.item.title}}</strong>
    </div>
  </suggestions>
</template>

<script>
import Suggestions from "v-suggestions";
import "v-suggestions/dist/v-suggestions.css";

export default {
  name: "category-finder",
  components: {
    Suggestions
  },
  props: {
    value: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      query: "",
      category: null,
      categories: [],
      options: {},
      searchTimeOut: null,
      searchQuery: ""
    };
  },
  created() {
    let self = this;
    axios({
      method: "get",
      url: "/api/v1/category/childs"
    })
      .then(res => {
        self.categories = res.data.data;
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    onItemSelected(item) {
      this.category = item;
      this.query = this.category.title;
    },
    onInputChange(query) {
      if (query.trim().length === 0) {
        return this.categories;
      }
      return this.categories.filter(category => {
        return category.title.toLowerCase().includes(query.toLowerCase());
      });
    }
  },
  watch: {
    category: {
      immediate: true,
      handler() {
        if (this.category != null && this.category != undefined) {
          this.$emit("input", this.category.id);
        }
      }
    },
    value: {
      immediate: true,
      handler() {
        if (
          this.category == null &&
          this.value != null &&
          this.value != undefined &&
          this.value != ""
        ) {
          let self = this;

          axios({
            method: "get",
            url: "/api/v1/category/" + self.value + "/show"
          })
            .then(res => {
              self.category = res.data.data;
              self.query = self.category.title;
            })
            .catch(err => {
              console.log(err);
            });
		}
		if(this.value == ''){
			this.query = null
		}
      }
    }
  }
};
</script>
